module.exports = __webpack_public_path__ + "img/wf.ea5aa6c3.svg";